import {AngularEditorConfig} from '@kolkov/angular-editor';
import {environment} from '../environments/environment';

export const SEARCH_DEBOUNCE_TIME = 700;
export const STATUS_CODE_SUCCESS = 200;

const refreshTokenConst = '/user/refreshToken';
const userLogoutConst = '/user/logout';
const appValueConst = '/appvalue';
const settingConst = '/user/setting';

export const RefreshTokenServicePathConst = `${environment.api.apiV1}${refreshTokenConst}`;
export const UserLogoutServicePathConst = `${environment.api.apiV1}${userLogoutConst}`;
export const AppValueServicePathConst = `${environment.api.apiV1}${appValueConst}`;
export const SessionServicePathConst = `${environment.api.apiV1}${settingConst}`;

// Format Datepicker
export const DATE_PICKER_FORMATS = {
	parse: {
		dateInput: ['DD-MM-YYYY'],
	},
	display: {
		dateInput: 'MM - DD - YYYY',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

// Angular Editor
export const EditorConfigConst: AngularEditorConfig = {
	editable: true,
	spellcheck: true,
	height: 'auto',
	minHeight: '10',
	maxHeight: 'auto',
	width: 'auto',
	minWidth: '0',
	translate: 'yes',
	enableToolbar: true,
	showToolbar: true,
	placeholder: 'Enter text here...',
	defaultParagraphSeparator: '',
	defaultFontName: '',
	defaultFontSize: '',
	fonts: [
		{ class: 'arial', name: 'Arial' },
		{ class: 'times-new-roman', name: 'Times New Roman' },
		{ class: 'calibri', name: 'Calibri' },
		{ class: 'comic-sans-ms', name: 'Comic Sans MS' },
	],
	customClasses: [
		{
			name: 'quote',
			class: 'quote',
		},
		{
			name: 'redText',
			class: 'redText',
		},
		{
			name: 'titleText',
			class: 'titleText',
			tag: 'h1',
		},
	],
	uploadUrl: 'v1/image',
	uploadWithCredentials: false,
	sanitize: true,
	toolbarPosition: 'top',
	toolbarHiddenButtons: [['bold', 'italic'], ['fontSize']],
};
